<template>
    <div class="schedule" :style="styles">
        <div class="row white">
            <schedule-date :date="schedule.date" :header="header" />
        </div>
        <div class="row">
            <schedule-stream
                v-for="stream in schedule.streams"
                :stream="stream"
                :key="stream.type"
            />
        </div>
    </div>
</template>

<script>
import ScheduleDate from '@/components/schedule/ScheduleDate'
import ScheduleStream from '@/components/schedule/ScheduleStream'

export default {
    name: 'EditionSchedule',
    components: {
        ScheduleDate,
        ScheduleStream
    },
    props: {
        category: { type: Object, required: true },
        schedule: { type: Object, required: true },
        header: { type: Object, required: true }
    },
    computed: {
        styles() {
            return {
                borderColor: this.category.color
            }
        }
    }
}
</script>

<style lang="sass" scoped>
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables
+mobile
    .schedule
        background-color: $color_background
        border-left: 4px solid $color_border
    .row
        padding: ($gap * 1.5) ($gap * 1.25)
        &.white
            background-color: $color_white

+desktop
    .schedule
        display: flex
        flex-direction: column
        align-items: center
        justify-content: center
        padding: ($gap * 5.5) 0

        .row + .row
            margin-top: ($gap * 1.5)
</style>
